import { RouterProvider } from 'react-router-dom';
import { appRouter } from '@/router';
import { PriceDisplayProvider } from '@/features/operations/PriceDisplayProvider';

function App() {
  return (
    <PriceDisplayProvider>
      <RouterProvider router={appRouter} />
    </PriceDisplayProvider>
  );
}

export default App;
